import Base from 'app/models/base';

export default Base.extend({
  initialize({
    choices, paramKey, label, staticKey, initialChoice,
  }) {
    this.choices = choices;
    this.paramKey = paramKey;
    this.label = label;
    this.staticKey = staticKey;
    this.setCurrentChoice(initialChoice);
  },

  getParamKey() {
    return this.paramKey;
  },

  getVal() {
    return this.get('currentChoice').option;
  },

  getReadable() {
    return this.get('currentChoice').readable;
  },

  getParams() {
    const val = this.getVal();
    return val ? { [this.getParamKey()]: val, ...this.staticKey } : {};
  },

  setCurrentChoice(val) {
    this.setChoiceIfValid(this.choices, val);
  },

  setChoiceIfValid(choices, val, setOptions = {}) {
    let newChoice;
    if (val) {
      newChoice = choices.find(c => c.option === (val[this.getParamKey()] || val));
    }
    if (newChoice || !(val instanceof Object)) {
      this.set('currentChoice', newChoice || choices[0], setOptions);
    }
  },

  getCurrentChoiceIdx() {
    return this.choices.findIndex(c => c.option === this.getVal());
  },

  setNextChoice() {
    const nextChoice = this.choices[this.getCurrentChoiceIdx() + 1];
    if (nextChoice) { this.set('currentChoice', nextChoice); }
  },

  setPreviousChoice() {
    const previousChoice = this.choices[this.getCurrentChoiceIdx() - 1];
    if (previousChoice) { this.set('currentChoice', previousChoice); }
  },
});



// WEBPACK FOOTER //
// ./app/models/selection.js